import { render } from "./ExpenseAmount.vue?vue&type=template&id=59cb8030&ts=true"
import script from "./ExpenseAmount.vue?vue&type=script&lang=ts"
export * from "./ExpenseAmount.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__